var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "rb-fieldrow": true,
        "rb-fieldrow-select": true,
        "rb-validrow": _vm.isValidRow,
        "rb-invalidrow": _vm.isInValidRow,
      },
    },
    [
      _vm.label
        ? _c(
            "label",
            {
              class: {
                "rb-field--required": _vm.required,
                "sr-only": _vm.sronly,
              },
              attrs: { for: _vm.id },
            },
            [
              _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
              !_vm.required
                ? _c("span", { staticClass: "rb-field--optional" }, [
                    _vm._v(" " + _vm._s(_vm.labelOptional)),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "rb-select-wrapper" }, [
        _c("span", {
          staticClass: "rb-select--arrows",
          attrs: { for: _vm.id },
        }),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.value,
                expression: "value",
              },
            ],
            attrs: {
              id: _vm.id,
              "aria-label": _vm.selectAriaLabel,
              disabled: _vm.disabled,
              name: _vm.name,
              required: _vm.required,
            },
            on: {
              change: [
                function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.value = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                _vm.onChange,
              ],
              blur: _vm.onBlur,
              focus: _vm.onFocus,
            },
          },
          [_vm._t("default")],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.helper && _vm.helperIsVisible
        ? _c("span", { staticClass: "rb-fieldrow__helper" }, [
            _vm._v(_vm._s(_vm.helper)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }